export enum Keyboard {
  enter = 'Enter',
  space = 'Space',
}
